import { Link } from 'react-router'
import { SectionHeading } from '@/components/ds/SectionHeading'
import { StatusPage } from '@/components/ds/StatusPage'
import { buttonVariants } from '@/components/ui/button'

const NotFound = () => {
  return (
    <StatusPage>
      <SectionHeading
        level={1}
        th="ไม่พบหน้าที่คุณต้องการ"
        en="Page not found"
        description="ลิงก์อาจไม่ถูกต้องหรือหน้านี้ถูกย้ายไปแล้ว"
      />
      <Link to="/" className={`${buttonVariants()} mt-8`}>
        กลับหน้าแรก
      </Link>
    </StatusPage>
  )
}

export default NotFound
